import { render, staticRenderFns } from "./checkUpStatusDetail.vue?vue&type=template&id=9fb7b332"
import script from "./checkUpStatusDetail.vue?vue&type=script&lang=js"
export * from "./checkUpStatusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fb7b332')) {
      api.createRecord('9fb7b332', component.options)
    } else {
      api.reload('9fb7b332', component.options)
    }
    module.hot.accept("./checkUpStatusDetail.vue?vue&type=template&id=9fb7b332", function () {
      api.rerender('9fb7b332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpStatusDetail.vue"
export default component.exports